<script lang="ts">
    import { getContext, onDestroy } from 'svelte'
    import Flatpickr from 'svelte-flatpickr'
    import { get, type Readable } from 'svelte/store'

    import type { GenOrder, IOrder } from '../../order'

    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import { simpleFetch, type SimpleFetchResult } from 'hydria/services/session'

    const orderId = getContext('orderId') as Readable<string>
    const Order = getContext('Order') as GenOrder

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    let order: IOrder = $state(get(Order.orderStore))

    interface Props {
        onSuccess: (ptype: string) => void
    }

    let { onSuccess }: Props = $props()

    interface IForm {
        confirmation_number: string
        wire_date: string
        comment: string
        user_instructions: string
    }

    let form: IForm = $state({
        user_instructions: '',
        confirmation_number: '',
        wire_date: '',
        comment: '',
    })

    unsubs.push(
        Order.orderStore.subscribe((v) => {
            order = v
            form.user_instructions = order.user_instructions ? order.user_instructions : ''
        }),
    )

    let error: string | undefined = $state()

    let working = $state(false)

    let fakeDate: string = $state('')

    async function submit() {
        working = true
        error = undefined

        const data: any = { ...form }
        data.revision = order.revision
        data.total = order.total

        let r: SimpleFetchResult
        try {
            r = await simpleFetch('POST', `/json/ecom/1/order/${$orderId}/payment/wire-transfer`, data)
        } catch (e: any) {
            console.error('Failed to process payment:', e)
            working = false
            error = e && e.data && e.data.error ? e.data.error : '?'
            notify({
                type: 'danger',
                title: $_('Payment'),
                text: $_('Une erreur s’est produite lors du paiement : {error}', { error: error }),
            })
            return
        }
        Order.loadGenericResponse(r.data)
        onSuccess('wire transfer')
    }
</script>

<form
    onsubmit={(e) => {
        e.preventDefault()
        submit()
    }}
    class="d-grid gap-2"
    novalidate
>
    {#if error}
        <div class="help-text alert alert-danger alert-card">
            <p>{error}</p>
        </div>
    {/if}

    <div class="row">
        <label for="confirmation_number" class="col-sm-3 col-form-label">Numéro de confirmation</label>
        <div class="col-sm-6">
            <input type="text" class="form-control" id="confirmation_number" bind:value={form.confirmation_number} disabled={working} />
        </div>
    </div>

    <div class="row">
        <label for="wire_date" class="col-sm-3 col-form-label">Date sur le chèque</label>
        <div class="col-sm-6">
            <Flatpickr options={{ element: '#wire-date' }} bind:formattedValue={form.wire_date} bind:value={fakeDate} dateFormat="Y-m-d" element="#wire-date">
                <div id="wire-date"><input type="text" class="form-control" data-input disabled={working} /></div>
            </Flatpickr>
        </div>
    </div>

    <div class="row">
        <label for="comment" class="col-sm-3 col-form-label">Commentaire</label>
        <div class="col-sm-6">
            <input type="text" class="form-control" id="comment" bind:value={form.comment} disabled={working} />
        </div>
    </div>

    <div class="row">
        <label for="user_instructions" class="col-sm-3 col-form-label">{$_('Instructions')}</label>
        <div class="col-sm-9">
            <textarea name="user_instructions" id="user_instructions" rows="2" placeholder={$_('Additional instructions or notes to be placed on the invoice.')} class="form-control" disabled={working} bind:value={form.user_instructions}></textarea>
        </div>
    </div>
    <div class="tab-footer text-end">
        <button type="submit" class="btn" disabled={working} class:btn-outline-secondary={working} class:btn-primary={!working}>
            {#if working}
                <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                {$_('Processing…')}
            {:else}
                {$_('Inscribe payment')}
            {/if}
        </button>
    </div>
</form>
